import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom";
import slick from "slick-carousel";
import GetTopNine from "./components/GetTopNine";
import TopNineDetail from "./components/TopNineDetail";
import EditTopNine from "./components/EditTopNine";
import retina from "./libs/retina";

const legalButton = ({ $ }) => {
  $(".legal").on("click", () => {
    $(".overlay").toggleClass("none"),
      $(".legal-scroll")
        .toggleClass("fadeInUp")
        .toggleClass("fadeOutDown");
  });
  $(".close").on("click", () => {
    $(".overlay").toggleClass("none"),
      $(".legal-scroll")
        .toggleClass("fadeOutDown")
        .toggleClass("fadeInUp");
  });
};

const reviewsSlider = ({ elem }) => {
  elem.slick({
    target: ".slide",
    autoplay: !0,
    slidesToShow: 1,
    arrows: !1,
    autoplaySpeed: 5e3,
    speed: 800,
    cssEase: "ease",
    visibility: "hidden",
  });
};

$(document).ready(function() {
  reviewsSlider({ elem: $(".reviews") }); // Breaks HMR
  legalButton({ $ });
  const getTopNineElement = document.getElementById("get-top-nine-app");
  if (getTopNineElement) {
    ReactDOM.render(<GetTopNine />, getTopNineElement);
  }

  const topNineDetailElement = document.getElementById("top-nine-detail-app");
  if (topNineDetailElement) {
    ReactDOM.render(<TopNineDetail />, topNineDetailElement);
  }

  const editTopNineElement = document.getElementById("edit-top-nine");
  if (editTopNineElement) {
    ReactDOM.render(<EditTopNine />, editTopNineElement);
  }
});
